import type { ChannelMask } from '../hooks/useChannelsForSettings'

export const isStartPage = (args: { channel: ChannelMask }): boolean => {
  const { channel } = args
  return channel?.service === 'startPage'
}
